import { render } from "./PreChatFormContainer.vue?vue&type=template&id=8466d8fa&scoped=true"
import script from "./PreChatFormContainer.vue?vue&type=script&lang=js"
export * from "./PreChatFormContainer.vue?vue&type=script&lang=js"

import "./PreChatFormContainer.vue?vue&type=style&index=0&id=8466d8fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8466d8fa"]])

export default __exports__